import { render, staticRenderFns } from "./aftersale_order_list.vue?vue&type=template&id=3fc4f76e&scoped=true"
import script from "./aftersale_order_list.vue?vue&type=script&lang=js"
export * from "./aftersale_order_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc4f76e",
  null
  
)

export default component.exports